// removed by extract-text-webpack-plugin
module.exports = {"tarrifPlan":"theme--tarrifPlan--a1bOeQV_"};


//////////////////
// WEBPACK FOOTER
// ./src/modules/home/pricing/theme.scss
// module id = 1014
// module chunks = 0